import { NodeViewContent, NodeViewWrapper } from '@tiptap/react';
import { TextSelection } from '@tiptap/pm/state';
import styles from './RichEditor.module.scss';

function placeNear(tr, pos) {
  const at = Math.max(0, Math.min(pos, tr.doc.content.size));
  tr.setSelection(TextSelection.near(tr.doc.resolve(at)));
}

/** The hidden word, edited like any other word in the sentence. */
export default function BlankView({ node, editor, getPos }) {
  const n = Number(node.attrs.n) > 0 ? Number(node.attrs.n) : 1;
  const empty = node.content.size === 0;
  const hint = node.attrs.hint || '';

  const focusInside = (e) => {
    e.preventDefault();
    const pos = getPos();
    if (typeof pos !== 'number') return;
    const end = pos + node.nodeSize - 1;
    editor.chain().focus().setTextSelection(end).run();
  };

  const remove = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const pos = getPos();
    if (typeof pos !== 'number') return;
    editor
      .chain()
      .focus()
      .command(({ tr, state }) => {
        const current = state.doc.nodeAt(pos);
        if (!current || current.type.name !== 'blank') return false;
        const size = current.content.size;
        tr.replaceWith(pos, pos + current.nodeSize, current.content);
        placeNear(tr, pos + size);
        return true;
      })
      .run();
  };

  return (
    <NodeViewWrapper
      as="span"
      className={styles.blank}
      data-blank={n}
      data-empty={empty ? 'true' : undefined}
      aria-label={empty ? `Blank ${n}` : undefined}
    >
      <span className={styles.badge} contentEditable={false} aria-hidden="true" onMouseDown={focusInside}>
        {n}
      </span>
      <NodeViewContent as="span" className={styles.answer} />
      {hint ? (
        <span className={styles.hint} contentEditable={false}>
          {hint}
        </span>
      ) : null}
      <button
        type="button"
        className={styles.unblank}
        contentEditable={false}
        aria-label={`Remove blank ${n}`}
        title="Keep the word, remove the blank"
        onPointerDown={remove}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') remove(e);
        }}
      >
        ×
      </button>
    </NodeViewWrapper>
  );
}
